import React from "react";
import ReactCookieConsent from "react-cookie-consent";
import styled from "styled-components";

const Wrapper = styled.div`
  position: fixed;
  top: var(--headerHeight);
  left: var(--col-6-13);
  width: var(--col-6-13);
  max-width: 100vw;
  z-index: 999999;
  background: white;
  @media all and (max-width: 991px) {
    left: 0;
    width: 100%;
    top: calc(var(--headerHeight) * 2);
  }
  .cookie-consent--content {
    padding: 5px 10px;
    & + div {
      display: flex;
      button {
      }
    }
  }
`;

const CookieConsent = () => {
  return (
    <Wrapper>
      <ReactCookieConsent
        containerClasses='cookie-consent'
        contentClasses='cookie-consent--content'
        disableStyles={true}
        location='bottom'
        buttonText='Accept all cookies'
        declineButtonText='Decline all cookies'
        cookieName='gatsby-gdpr-google-analytics'
        buttonClasses='button'
        acceptOnScroll={false}>
        We use first-party and third-party cookies for analytical purposes and
        to show you advertising related to your preferences, based on your
        browsing habits and profile. You can configure or block cookies by
        clicking on “Cookies settings”. You can also accept all cookies by
        clicking on “Accept all cookies”. Consult our Cookie Policy
      </ReactCookieConsent>
    </Wrapper>
  );
};

export default CookieConsent;
